QS<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="登录日志" name="0">登录日志</el-tab-pane>
      <el-tab-pane label="计划任务执行日志" name="1"
        >计划任务执行日志</el-tab-pane
      >
      <el-tab-pane label="操作日志" name="2">操作日志</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      activeName: "0"
    };
  },
  methods: {
    handleClick(tab, event) {}
  }
};
</script>

<style lang="scss" scoped></style>
